import { createContext, useContext, useState } from "react";

const DICT = {
  id: {
    nav_explore: "Jelajahi Aksi",
    nav_match: "Kenali Dirimu",
    nav_planner: "Social Action Planner",
    nav_organizer: "Organizer Hub",
    nav_profile: "Profil & Dampak Saya",
    search_placeholder: "Cari aksi...",
    create_initiative: "Buat Inisiatif",
    city_label: "Kota:",
    all_cities: "Semua Kota",
    hero_badge: "Alpha Pilot Phase (Q1 2026) — Validated Impact",
    hero_title_1: "Dari Niat Baik,",
    hero_title_2: "Jadi Aksi Nyata.",
    hero_sub: "Temukan aksi sosial paling cocok dengan keahlianmu, dapatkan playbook solusi untuk masalah di lingkunganmu, dan bergabung dengan relawan terverifikasi angkatan pertama Alpha Pilot kami.",
    hero_cta_match: "Mulai Kenali Dirimu",
    hero_cta_explore: "Jelajahi Aksi",
    stat_volunteers: "Relawan Aktif",
    stat_hours: "Jam Kontribusi",
    stat_projects: "Proyek Selesai",
    stat_beneficiaries: "Penerima Manfaat",
    feature_match_desc: "Jawab 4 pertanyaan, dapatkan profil aksi personal & rekomendasi kegiatan paling cocok.",
    feature_planner_desc: "Rencanakan aksi warga, komunitas, hingga program CSR — AI menyusun playbook 8 bagian lengkap.",
    feature_explore_desc: "Filter berdasarkan isu, format, dan kota. Lihat peta sebaran aksi di seluruh Indonesia.",
    open: "Buka",
    nearby_title: "Aksi Terdekat Membutuhkanmu",
    nearby_sub: "Inisiatif komunitas dengan slot relawan yang masih terbuka.",
    see_all: "Lihat Semua",
    tour_label: "Quick Demo Tour",
    tour_match: "1. Coba Kenali Dirimu",
    tour_planner: "2. Coba Social Action Planner",
    tour_dashboard: "3. Dasbor Dampak B2B",
    explore_title: "Jelajahi Aksi & Komunitas",
    explore_sub: "Temukan inisiatif warga terverifikasi di sekitarmu.",
    planner_title_1: "Punya Masalah di Lingkunganmu?",
    planner_title_2: "AI Susun Rencana Aksinya.",
    planner_sub: "Mesin perencana aksi adaptif multi-sektor: dari aksi warga hingga program CSR — playbook operasional 8 bagian, dokumen resmi, dan jembatan menjadi proyek komunitas.",
    planner_problem_label: "Ceritakan masalah lingkungan atau sosial yang dihadapi dan rencanakan aksi sosial/CSR sekarang.",
    planner_generate: "Buat Rencana Aksi",
    planner_generating: "AI Menyusun Playbook...",
    templates_title: "Community Action Library — Template Cepat",
    organizer_title: "Organizer Hub",
    organizer_sub: "Kelola inisiatif, relawan, laporan warga, dan dampak organisasimu.",
    export_report: "Ekspor Laporan Dampak",
    demo_badge: "Alpha Pilot Q1 2026 — Validated Impact",
    sample_badge: "Alpha Pilot Q1 2026 — Validated Impact",
    profile_badges: "Lencana Dampak",
    profile_history: "Riwayat Aksi",
    convert_ready: "Rencana Aksimu Siap — Jadikan Proyek Komunitas",
    convert_btn: "Convert to Community Project",
    convert_desc: "Publikasikan rencana ini sebagai proyek di Organizer Hub & Jelajahi Aksi — lengkap dengan peran relawan dan target indikator.",
    convert_success: "Proyek komunitas berhasil dipublikasikan ke Jelajahi Aksi & Organizer Hub!",
    convert_error: "Gagal mengonversi rencana menjadi proyek.",
    pb_s1: "Analisis Masalah & Tujuan",
    pb_s2: "Timeline Implementasi",
    pb_s3: "Matriks Peran & Tugas Relawan",
    pb_s4: "3 Skenario Anggaran & Logistik",
    pb_s5: "Keselamatan, Risiko & Mitigasi",
    pb_s6: "Rekomendasi Mitra & Stakeholder",
    pb_s7: "Keselarasan SDG & Indikator Dampak",
    pb_s8: "Generator Dokumen Administratif & Legal",
    pb_root: "Akar Masalah",
    pb_benef: "Penerima Manfaat",
    pb_goals: "Tujuan Terukur",
    pb_reco: "REKOMENDASI",
    mx_title: "Aktivitas → Output → Outcome (Status Bukti)",
    mx_all_cat: "Semua Kategori",
    mx_all_status: "Semua Status",
    mx_activity: "Aktivitas",
    mx_output: "Output Langsung",
    mx_outcome: "Outcome Terverifikasi",
    mx_status: "Status",
    mx_evidence: "Bukti",
    mx_evidence_status: "Status Bukti",
    mx_empty: "Tidak ada data sesuai filter.",
    rp_page: "Halaman",
    rp_subtitle: "CSR & Community Readiness · Alpha Pilot Q1 2026 · 3 Halaman",
    rp_title1: "Ringkasan Eksekutif, Indikator Kunci & Dokumentasi",
    rp_title2: "Kontribusi SDG, Matriks Output vs Outcome & Analitik Relawan",
    rp_title3: "Evaluasi, Tantangan Lapangan, Pembelajaran & Langkah Lanjut",
    rp_stat_vol: "Relawan Dimobilisasi",
    rp_stat_act: "Aktivitas Selesai",
    rp_stat_att: "Kehadiran Terverifikasi (PIN/QR)",
    rp_stat_hours: "Jam Relawan",
    rp_stat_cities: "Kota Terjangkau",
    rp_stat_benef: "Penerima Manfaat Terjangkau",
    rp_econ: "Valuasi Ekonomi Transparan",
    rp_formula_mid: "Total Jam Relawan ×",
    rp_formula_end: "/jam (estimasi nilai standar)",
    rp_source: "Sumber data: sistem check-in PIN/QR, laporan organizer, dan dokumentasi lapangan. Status bukti ditandai per proyek di halaman 2.",
    rp_sdg_head: "Kontribusi SDG & Justifikasi Metodologi",
    rp_matrix_head: "Matriks Aktivitas → Output → Outcome Terverifikasi",
    rp_va_head: "Analitik Relawan",
    rp_va_return: "Relawan Kembali / Baru",
    rp_va_att: "Tingkat Kehadiran",
    rp_challenges: "Tantangan Lapangan",
    rp_lessons: "Pembelajaran",
    rp_next: "Langkah Lanjut",
    rp_resolution: "Rasio penyelesaian isu lingkungan",
    rp_footer: "Disusun otomatis oleh BergerakNyata — data Alpha Pilot Q1 2026 tervalidasi, siap audit untuk pelaporan CSR & ESG mitra.",
    rp_close: "Tutup",
    rp_print: "Unduh / Cetak Laporan PDF",
    rp_public_title: "Laporan Dampak Publik",
    rp_public_sub: "Versi publik yang dapat dibagikan — Alpha Pilot Q1 2026, Dampak Tervalidasi.",
    rp_public_print: "Cetak",
    ikuti_aksi: "Ikuti Aksi",
    kuota_penuh: "Kuota Penuh",
    aksi_selesai: "Aksi Selesai ✓",
    mm_badge: "Kenali Dirimu — AI Civic Matchmaker",
    mm_title: "Temukan Peran Sipilmu",
    mm_sub: "4 langkah singkat untuk profil aksi personal berbasis AI.",
    mm_step1: "Keahlian Utama",
    mm_step2: "Ketersediaan Waktu",
    mm_step3: "Fokus Isu Sosial",
    mm_step4: "Lokasi / Domisili",
    mm_q1: "Apa keahlian utamamu?",
    mm_q1_sub: "Pilih satu atau lebih.",
    mm_q2: "Berapa banyak waktu yang bisa kamu berikan?",
    mm_q3: "Isu sosial apa yang paling kamu pedulikan?",
    mm_q4: "Di mana domisilimu?",
    mm_back: "Kembali",
    mm_next: "Lanjut",
    mm_submit: "Buat Profil Aksi Saya",
    mm_loading: "AI sedang menganalisis profil sipilmu...",
    mm_loading_sub: "Mencocokkan keahlian, waktu, dan fokus isu dengan aksi paling berdampak.",
    skill_desain: "Desain",
    skill_logistik: "Logistik",
    skill_pengajaran: "Pengajaran",
    skill_legal: "Legal/Advokasi",
    skill_media: "Media/Komunikasi",
    skill_medis: "Medis/Kesehatan",
    skill_lapangan: "Tenaga Lapangan",
    avail_1: "Insidental 1 Hari",
    avail_2: "Akhir Pekan",
    avail_3: "2-4 Jam/Minggu",
    avail_4: "Proyek Jangka Panjang",
    focus_1: "Lingkungan & Sampah",
    focus_2: "Pendidikan & Anak",
    focus_3: "Kemiskinan & Pangan",
    focus_4: "Kesetaraan Sosial & Gender",
    focus_5: "Bencana Alam",
    actor_q: "Siapa pelaksana aksinya?",
    actor_1: "Warga / Individu",
    actor_2: "Komunitas / Relawan",
    actor_3: "Perusahaan / CSR",
    actor_4: "Institusi / Kampus",
    budget_ph: "Alokasi Dana (Rp) — opsional",
    budget_ph_corp: "Alokasi Dana (Rp) — direkomendasikan",
    region_ph: "Kota / Wilayah Target",
    cat_ph: "Kategori Aksi",
    benef_ph: "Target Penerima Manfaat",
    vol_ph: "Relawan Tersedia (orang)",
    duration_ph: "Durasi",
    resources_ph: "Sumber daya non-uang (tempat, alat, jejaring)",
    org_stat_vol: "Total Relawan Dimobilisasi",
    org_stat_hours: "Jam Relawan Terkontribusi",
    org_stat_projects: "Proyek Selesai Terverifikasi",
    org_stat_active: "Kegiatan Aktif",
    org_stat_benef: "Penerima Manfaat Terjangkau",
    tab_metrics: "Metrik Dampak",
    tab_apps: "Aplikasi Relawan",
    tab_listing: "Buat Listing Baru",
    tab_attendance: "Daftar Hadir",
    tab_reports: "Laporan Warga",
    org_loading: "Memuat dashboard...",
    chart_monthly: "Relawan & Jam per Bulan (Alpha Pilot Q1 2026)",
    chart_category: "Distribusi per Kategori (%)",
    ci_title: "Verifikasi Kehadiran Aksi",
    ci_sub: "Masukkan kode PIN harian dari panitia di lokasi — tanpa kamera, tanpa sinyal kuat.",
    ci_step1: "1. Pilih Kegiatan",
    ci_select_ph: "Pilih aksi yang kamu ikuti...",
    ci_step2: "2. Kode PIN Harian dari Panitia",
    ci_verify: "Verifikasi Kehadiran",
    ci_alt: "Jalur Alternatif: Scan QR di Lokasi",
    ci_alt_sub: "Opsi pelengkap cepat bila poster QR tersedia di posko.",
    ci_qr_btn: "Simulasi Scan QR / Check-in",
    ci_recorded: "Kehadiran Tercatat!",
    ci_again: "Catat Kehadiran Lain",
    prof_loading: "Memuat profil...",
    prof_hours: "Jam Terverifikasi",
    prof_actions: "Aksi Selesai",
    prof_saved: "Rencana Aksi Tersimpan",
    prof_cert: "Sertifikat",
    prof_no_badges: "Belum ada lencana. Ikuti dan selesaikan aksi pertamamu untuk mendapatkannya!",
    prof_no_history: "Belum ada riwayat aksi. Daftar aksi di Jelajahi Aksi lalu verifikasi kehadiranmu dengan PIN panitia.",
    prof_no_plans: "Belum ada rencana tersimpan. Coba AI Matchmaker dan simpan hasilnya di sini.",
    bdg_green: "2 aksi lingkungan pilot terverifikasi",
    bdg_pioneer: "Relawan angkatan pertama Alpha Pilot Q1 2026",
    bdg_coord: "Koordinator lapangan Alpha Pilot Q1 2026",
    bdg_orgpro: "Mengelola 2 aksi pilot terverifikasi",
  },
  en: {
    nav_explore: "Explore Actions",
    nav_match: "Discover Your Role",
    nav_planner: "Social Action Planner",
    nav_organizer: "Organizer Hub",
    nav_profile: "My Profile & Impact",
    search_placeholder: "Search actions...",
    create_initiative: "Create Initiative",
    city_label: "City:",
    all_cities: "All Cities",
    hero_badge: "Alpha Pilot Phase (Q1 2026) — Validated Impact",
    hero_title_1: "From Good Intentions,",
    hero_title_2: "To Real Action.",
    hero_sub: "Find the social actions that best match your skills, get AI solution playbooks for problems around you, and join the first cohort of verified volunteers in our Alpha Pilot.",
    hero_cta_match: "Start Discover Your Role",
    hero_cta_explore: "Explore Actions",
    stat_volunteers: "Active Volunteers",
    stat_hours: "Contribution Hours",
    stat_projects: "Projects Completed",
    stat_beneficiaries: "Beneficiaries Reached",
    feature_match_desc: "Answer 4 questions and get a personal action profile with best-matched activities.",
    feature_planner_desc: "Plan citizen, community, or CSR programs — AI builds a complete 8-part playbook.",
    feature_explore_desc: "Filter by issue, format, and city. View the action map across Indonesia.",
    open: "Open",
    nearby_title: "Nearby Actions Need You",
    nearby_sub: "Community initiatives with open volunteer slots.",
    see_all: "See All",
    tour_label: "Quick Demo Tour",
    tour_match: "1. Try Discover Your Role",
    tour_planner: "2. Try Social Action Planner",
    tour_dashboard: "3. B2B Impact Dashboard",
    explore_title: "Explore Actions & Communities",
    explore_sub: "Find verified citizen initiatives around you.",
    planner_title_1: "Facing a Problem in Your Area?",
    planner_title_2: "Let AI Draft the Action Plan.",
    planner_sub: "Adaptive multi-sector action planner: from citizen actions to CSR programs — an 8-part operational playbook, formal documents, and a bridge into a community project.",
    planner_problem_label: "Describe the environmental or social problem you face and plan your social/CSR action now.",
    planner_generate: "Generate Action Plan",
    planner_generating: "AI is Building the Playbook...",
    templates_title: "Community Action Library — Quick Templates",
    organizer_title: "Organizer Hub",
    organizer_sub: "Manage initiatives, volunteers, citizen reports, and your organization's impact.",
    export_report: "Export Impact Report",
    demo_badge: "Alpha Pilot Q1 2026 — Validated Impact",
    sample_badge: "Alpha Pilot Q1 2026 — Validated Impact",
    profile_badges: "Impact Badges",
    profile_history: "Action History",
    convert_ready: "Your Action Plan Is Ready — Convert to Community Project",
    convert_btn: "Convert to Community Project",
    convert_desc: "Publish this plan as a project in the Organizer Hub & Explore Actions — complete with volunteer roles and target indicators.",
    convert_success: "Community project published to Explore Actions & Organizer Hub!",
    convert_error: "Failed to convert the plan into a project.",
    pb_s1: "Problem Analysis & Goals",
    pb_s2: "Implementation Timeline",
    pb_s3: "Volunteer Roles & Task Matrix",
    pb_s4: "3 Budget & Logistics Scenarios",
    pb_s5: "Safety, Risks & Mitigation",
    pb_s6: "Partner & Stakeholder Recommendations",
    pb_s7: "SDG Alignment & Impact Indicators",
    pb_s8: "Administrative & Legal Document Generator",
    pb_root: "Root Cause",
    pb_benef: "Beneficiaries",
    pb_goals: "Measurable Goals",
    pb_reco: "RECOMMENDED",
    mx_title: "Activity → Output → Outcome (Evidence Status)",
    mx_all_cat: "All Categories",
    mx_all_status: "All Statuses",
    mx_activity: "Activity",
    mx_output: "Direct Output",
    mx_outcome: "Verified Outcome",
    mx_status: "Status",
    mx_evidence: "Evidence",
    mx_evidence_status: "Evidence Status",
    mx_empty: "No data matches the filters.",
    rp_page: "Page",
    rp_subtitle: "CSR & Community Readiness · Alpha Pilot Q1 2026 · 3 Pages",
    rp_title1: "Executive Summary, Key Indicators & Documentation",
    rp_title2: "SDG Contribution, Output vs Outcome Matrix & Volunteer Analytics",
    rp_title3: "Evaluation, Field Challenges, Lessons & Next Steps",
    rp_stat_vol: "Volunteers Mobilized",
    rp_stat_act: "Activities Completed",
    rp_stat_att: "Verified Attendance (PIN/QR)",
    rp_stat_hours: "Volunteer Hours",
    rp_stat_cities: "Cities Reached",
    rp_stat_benef: "Beneficiaries Reached",
    rp_econ: "Transparent Economic Valuation",
    rp_formula_mid: "Total Volunteer Hours ×",
    rp_formula_end: "/hour (standard value estimate)",
    rp_source: "Data sources: PIN/QR check-in system, organizer reports, and field documentation. Evidence status is flagged per project on page 2.",
    rp_sdg_head: "SDG Contribution & Methodology Justification",
    rp_matrix_head: "Verified Activity → Output → Outcome Matrix",
    rp_va_head: "Volunteer Analytics",
    rp_va_return: "Returning / New Volunteers",
    rp_va_att: "Attendance Rate",
    rp_challenges: "Field Challenges",
    rp_lessons: "Lessons Learned",
    rp_next: "Next Steps",
    rp_resolution: "Environmental issue resolution ratio",
    rp_footer: "Automatically compiled by BergerakNyata — validated Alpha Pilot Q1 2026 data, audit-ready for partner CSR & ESG reporting.",
    rp_close: "Close",
    rp_print: "Download / Print PDF Report",
    rp_public_title: "Public Impact Report",
    rp_public_sub: "Shareable public version — Alpha Pilot Q1 2026, Validated Impact.",
    rp_public_print: "Print",
    ikuti_aksi: "Join Action",
    kuota_penuh: "Slots Full",
    aksi_selesai: "Action Completed ✓",
    mm_badge: "Discover Your Role — AI Civic Matchmaker",
    mm_title: "Discover Your Civic Role",
    mm_sub: "4 quick steps to generate your AI-driven civic action profile.",
    mm_step1: "Core Skills",
    mm_step2: "Time Availability",
    mm_step3: "Social Issue Focus",
    mm_step4: "Location / Domicile",
    mm_q1: "What are your core skills?",
    mm_q1_sub: "(Select one or more)",
    mm_q2: "How much time can you contribute?",
    mm_q3: "Which social issue do you care about most?",
    mm_q4: "Where are you located?",
    mm_back: "Back",
    mm_next: "Next Step",
    mm_submit: "Generate Match",
    mm_loading: "AI is analyzing your civic profile...",
    mm_loading_sub: "Matching your skills, time, and issue focus with the highest-impact actions.",
    skill_desain: "Design & Creative",
    skill_logistik: "Logistics & Fieldwork",
    skill_pengajaran: "Teaching & Education",
    skill_legal: "Legal & Advocacy",
    skill_media: "Media & Communications",
    skill_medis: "Healthcare & Medical",
    skill_lapangan: "Field Operations",
    avail_1: "One-day (Incidental)",
    avail_2: "Weekends",
    avail_3: "2-4 Hours/Week",
    avail_4: "Long-term Project",
    focus_1: "Environment & Waste",
    focus_2: "Education & Children",
    focus_3: "Poverty & Food Security",
    focus_4: "Social Equality & Gender",
    focus_5: "Disaster Response",
    actor_q: "Who is leading this social action?",
    actor_1: "Citizen / Individual",
    actor_2: "Community / Volunteer",
    actor_3: "Corporate / CSR",
    actor_4: "Institution / Campus",
    budget_ph: "Allocated Budget (IDR) — optional",
    budget_ph_corp: "Allocated Budget (IDR) — recommended",
    region_ph: "Target City / Region",
    cat_ph: "Action Category",
    benef_ph: "Target Beneficiaries",
    vol_ph: "Available Volunteers",
    duration_ph: "Duration",
    resources_ph: "Non-monetary resources (venue, tools, networks)",
    org_stat_vol: "Total Volunteers Mobilized",
    org_stat_hours: "Volunteer Hours Contributed",
    org_stat_projects: "Verified Completed Projects",
    org_stat_active: "Active Activities",
    org_stat_benef: "Beneficiaries Reached",
    tab_metrics: "Impact Metrics",
    tab_apps: "Volunteer Applications",
    tab_listing: "Create New Listing",
    tab_attendance: "Attendance Sheet",
    tab_reports: "Citizen Reports",
    org_loading: "Loading dashboard...",
    chart_monthly: "Volunteers & Hours per Month (Alpha Pilot Q1 2026)",
    chart_category: "Distribution by Category (%)",
    ci_title: "Verify Action Attendance",
    ci_sub: "Enter the daily PIN from the on-site organizer — no camera, no strong signal needed.",
    ci_step1: "1. Select Initiative",
    ci_select_ph: "Select the initiative you attended...",
    ci_step2: "2. Daily Organizer PIN",
    ci_verify: "Verify Attendance",
    ci_alt: "Alternative Option: Scan QR on Site",
    ci_alt_sub: "A quick complementary option when a QR poster is available at the post.",
    ci_qr_btn: "Simulate QR Scan / Check-in",
    ci_recorded: "Attendance Recorded!",
    ci_again: "Record Another Attendance",
    prof_loading: "Loading profile...",
    prof_hours: "Verified Hours",
    prof_actions: "Actions Completed",
    prof_saved: "Saved Action Plans",
    prof_cert: "Certificate",
    prof_no_badges: "No badges yet. Join and complete your first action to earn one!",
    prof_no_history: "No action history yet. Register via Explore Actions, then verify attendance with the organizer PIN.",
    prof_no_plans: "No saved plans yet. Try the AI Matchmaker and save the result here.",
    bdg_green: "2 verified environmental pilot actions",
    bdg_pioneer: "First-cohort volunteer of Alpha Pilot Q1 2026",
    bdg_coord: "Field coordinator of Alpha Pilot Q1 2026",
    bdg_orgpro: "Managed 2 verified pilot actions",
  },
};

const STORAGE_KEY = "bn.lang";
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem(STORAGE_KEY) || "id");
  const setLang = (l) => { setLangState(l); localStorage.setItem(STORAGE_KEY, l); };
  const t = (key) => DICT[lang]?.[key] ?? DICT.id[key] ?? key;
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
